import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	// reorder ===========
	priorityReorderFailedFlagTitle: {
		id: 'admin-pages-priorities.controllers.priorities-page.notifications.priority-reorder-failed-flag-title',
		defaultMessage: 'Something went wrong',
		description:
			'Title for the flag that is shown when the user tries to reorder priorities and it fails',
	},
	priorityReorderFailedFlagBody: {
		id: 'admin-pages-priorities.controllers.priorities-page.notifications.priority-reorder-failed-flag-body',
		defaultMessage: 'Please try to move the priority again.',
		description:
			'Description for the flag that is shown when the user tries to reorder priorities and it fails',
	},
	// create ===========
	priorityCreateSuccessFlagTitle: {
		id: 'admin-pages-priorities.controllers.priorities-page.notifications.priority-create-success-flag-title',
		defaultMessage: '{priorityName} was added',
		description:
			'Title for the flag that is shown when the user tries to create a priority and succeeds',
	},
	priorityCreateSuccessFlagBody: {
		id: 'admin-pages-priorities.controllers.priorities-page.notifications.priority-create-success-flag-body',
		defaultMessage: 'Find it at the end of the priority list.',
		description:
			'Title for the flag that is shown when the user tries to create a priority and succeeds',
	},
	priorityCreateErrorFlagTitle: {
		id: 'admin-pages-priorities.controllers.priorities-page.notifications.priority-create-error-flag-title',
		defaultMessage: 'Something went wrong',
		description:
			'Title for the flag that is shown when the user tries to create a priority and fails',
	},
	priorityCreateErrorFlagBody: {
		// used if the error does not have a message to display
		// eslint-disable-next-line jira/i18n/id-named-by-package -- PLEASE FIX THIS SUPPRESSION
		id: 'admin-pages-priorities.controllers.priorities-page.notifications.priority-create-default-error-flag-body',
		defaultMessage: 'Please try again.',
		description:
			'Description for the flag that is shown when the user tries to create a priority and fails with no useful Error',
	},
	// edit ===========
	priorityEditSuccessFlagTitle: {
		id: 'admin-pages-priorities.controllers.priorities-page.notifications.priority-edit-success-flag-title',
		defaultMessage: '{priorityName} was updated',
		description:
			'Title for the flag that is shown when the user tries to create a priority and succeeds',
	},
	priorityEditErrorFlagTitle: {
		id: 'admin-pages-priorities.controllers.priorities-page.notifications.priority-edit-error-flag-title',
		defaultMessage: 'Something went wrong',
		description:
			'Title for the flag that is shown when the user tries to create a priority and fails',
	},
	priorityEditErrorFlagBody: {
		id: 'admin-pages-priorities.controllers.priorities-page.notifications.priority-edit-error-flag-body',
		defaultMessage: 'Please try again.',
		description:
			'Description for the flag that is shown when the user tries to create a priority and fails',
	},
	// Delete ===========
	priorityDeleteErrorFlagTitle: {
		id: 'admin-pages-priorities.controllers.priorities-page.notifications.priority-delete-error-flag-title',
		defaultMessage: 'We can’t delete {priorityName}.',
		description:
			'Title for the flag that is shown when the user tries to delete a priority and it fails',
	},
	priorityDeleteErrorFlagBody: {
		id: 'admin-pages-priorities.controllers.priorities-page.notifications.priority-delete-error-flag-body',
		defaultMessage: 'Please refresh and try again.',
		description:
			'Description for the flag that is shown when the user tries to delete a priority and it fails',
	},
	priorityDeleteStartFlagTitle: {
		id: 'admin-pages-priorities.controllers.priorities-page.notifications.priority-delete-start-flag-title',
		defaultMessage: "We're deleting {priorityName}",
		description: 'Title for the flag that is shown when the user starts deletion of a priority',
	},
	priorityDeleteStartFlagBody: {
		id: 'admin-pages-priorities.controllers.priorities-page.notifications.priority-delete-start-flag-body',
		defaultMessage: 'This will take a few minutes.',
		description:
			'Description for the flag that is shown when the user starts deletion of a priority',
	},
	priorityDeleteSuccessFlagTitle: {
		id: 'admin-pages-priorities.controllers.priorities-page.notifications.priority-delete-success-flag-title',
		defaultMessage: '{priorityName} is deleted',
		description: 'Title for the flag that is shown when deletion of a priority is successful',
	},
	priorityDeleteSuccessFlagBody: {
		id: 'admin-pages-priorities.controllers.priorities-page.notifications.priority-delete-success-flag-body',
		defaultMessage: 'It will no longer appear in your priority list.',
		description: 'Description for the flag that is shown when deletion of a priority is successful',
	},
});
